import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import "./Title.css";
import { Link } from "@material-ui/core";

const Title = () => {
  useEffect(() => {
    document.title = "OKR Cheat Sheet | Mesh";
  }, []);
  let { pathid, subid } = useParams();

  const [data, setData] = useState("");
  const [back, setback] = useState("");
  useEffect(() => {
    console.log(pathid);
    if (pathid === undefined) {
      setData("Select the department to know their OKRs");
    } else {
      setback("/okrs");
      setData("Select the role to see OKRs");
    }
    if (subid !== undefined) {
      setback("/cheatsheet/" + pathid);
      setData("Enter Email to see cheatsheet");
    }
    console.log(back);
  }, [pathid, subid, data, back]);
  return (
    <div className="title_data">
      {pathid && (
        <div>
          <a href={back}>
            <ArrowBackIcon />
          </a>
        </div>
      )}
      <div>{data}</div>
      {pathid && <div></div>}
    </div>
  );
};

export default Title;
